/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RequestManagerNotificationActionData } from './RequestManagerNotificationActionData';
import {
    RequestManagerNotificationActionDataFromJSON,
    RequestManagerNotificationActionDataFromJSONTyped,
    RequestManagerNotificationActionDataToJSON,
} from './RequestManagerNotificationActionData';

/**
 * 
 * @export
 * @interface RequestManagerNotificationAction
 */
export interface RequestManagerNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof RequestManagerNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof RequestManagerNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof RequestManagerNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {RequestManagerNotificationActionData}
     * @memberof RequestManagerNotificationAction
     */
    data: RequestManagerNotificationActionData;
}

/**
 * Check if a given object implements the RequestManagerNotificationAction interface.
 */
export function instanceOfRequestManagerNotificationAction(value: object): value is RequestManagerNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function RequestManagerNotificationActionFromJSON(json: any): RequestManagerNotificationAction {
    return RequestManagerNotificationActionFromJSONTyped(json, false);
}

export function RequestManagerNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestManagerNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': RequestManagerNotificationActionDataFromJSON(json['data']),
    };
}

export function RequestManagerNotificationActionToJSON(value?: RequestManagerNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': RequestManagerNotificationActionDataToJSON(value.data),
    };
}

